module.exports = __webpack_public_path__ + "static/media/GreekCookies.a60fc8b6.jpeg";